module.exports = __webpack_public_path__ + "img/iconminiline.38c1ba31.png";